/**
 * Floating widget row — Consentmo, accessiBe, Google merchant.
 *
 * Desktop: the three sit in a horizontal row at the bottom right.
 * Mobile:  they move inside the menu drawer to the bottom right.
 * 
 * Loaded from layout/theme.liquid, beside the widget scripts it manages.
 *
 * Beyond layout this also carries a set of third-party workarounds that are not
 * optional — stacking order between the widgets and their own panels, accessiBe's
 * shadow-DOM icon and transition fixes, keeping widget taps from closing the
 * mobile menu, and giving Google's untitled badge iframe an accessible name
 * (Lighthouse "frame-title").
 */
(function () {
  'use strict';

  if (window.__argFloatingWidgets) return;
  window.__argFloatingWidgets = true;

  var rt_aligned = true;
  rt_aligned = false; // left aligned

  /* ---------- config ---------- */
  var DRAWER_ID  = 'header-sidebar-menu';   // Impact mobile nav <navigation-drawer>
  var DESKTOP_MQ = '(min-width: 1150px)';   // theme's lg breakpoint
  var DT_INSET   = 20;  // desktop: row inset from right edge
  var DT_BASE    = 20;  // desktop: row offset from bottom
  var G_ICON_PAD = 8;   // compensation for transparent padding inside Google's wrapper
  var M_SIDE     = 16;  // mobile row: inset from menu panel's right edge
  var M_BOTTOM   = 84;  // mobile row: offset up from menu panel's bottom edge
  var GAP        = 14;  // visual gap between widgets

  var DT_ACSB_GAP_RIGHT = 8;
  var DT_ACSB_RIGHT    = 103;
  var DT_ACSB_BOTTOM   = 40;
  var DT_SHIELD_RIGHT  = 162;
  var DT_SHIELD_BOTTOM = 35;

  var G_FRAME_TITLE = 'Google Store Quality badge'; // accessible name for Google's iframe

  var mqDesktop = window.matchMedia(DESKTOP_MQ);
  var cache = {};
  var scheduled = false;
  var writeCount = 0;
  var hotTicks = 0;
  var pauseUntil = 0;
  var lastGw = 84, lastGh = 84;
  var ducked = false;


  /* ---------- scheduler ---------- */
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var fired = false;
    var raf = requestAnimationFrame(go);
    var tmo = setTimeout(go, 80);
    function go() {
      if (fired) return;
      fired = true;
      cancelAnimationFrame(raf);
      clearTimeout(tmo);
      scheduled = false;
      run();
    }
  }

  /* ---------- element resolution ---------- */
  function watchStyle(el) {
    if (el.__ptObs) return;
    el.__ptObs = true;
    new MutationObserver(schedule).observe(el, { attributes: true, attributeFilter: ['style'] });
  }
  function watchClassStyle(el) {
    if (el.__ptObs) return;
    el.__ptObs = true;
    new MutationObserver(schedule).observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  function watchGoogle(el) {
    if (el.__ptObs) return;
    el.__ptObs = true;
    new MutationObserver(schedule).observe(el, { attributes: true, attributeFilter: ['style'], childList: true });
  }
  function live(key, find) {
    var el = cache[key];
    if (el && el.isConnected) return el;
    el = find() || null;
    cache[key] = el;
    if (el && key === 'g') watchGoogle(el);
    if (el && key === 'a') watchClassStyle(el);
    if (el && key === 's') {
      var root = el.getRootNode();
      if (root && !root.__ptObs) {
        root.__ptObs = true;
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      }
    }
    return el;
  }
  function google() { return live('g', function () { return document.getElementById('google-merchantwidget-iframe-wrapper'); }); }
  function shield() {
    return live('s', function () {
      var h = document.querySelector('csm-cookie-consent');
      if (!h || !h.shadowRoot) return null;
      var t = h.shadowRoot.querySelector('[class*="reopen"]');
      while (t && getComputedStyle(t).position !== 'fixed') t = t.parentElement;
      return t;
    });
  }
  function acsb() {
    return live('a', function () {
      var hosts = document.querySelectorAll('access-widget-ui');
      for (var i = 0; i < hosts.length; i++) {
        if (!hosts[i].shadowRoot) continue;
        var b = hosts[i].shadowRoot.querySelector('button[class*="trigger-button"]');
        if (b) { patchAcsbShadow(hosts[i]); return b; }
      }
      return null;
    });
  }

  function patchAcsbShadow(host) {
    if (!host.shadowRoot || host.shadowRoot.getElementById('arg17-acsb-fix')) return;
    var st = document.createElement('style');
    st.id = 'arg17-acsb-fix';
    st.textContent = [
      '.trigger-button,[class*="trigger-button"]{transition:transform .15s!important;}',
      '.icon svg{visibility:inherit!important;}'
    ].join('');
    host.shadowRoot.appendChild(st);
  }

  /* ---------- Google iframe accessible name ---------- */
  function titleGoogleFrame(g) {
    var frames = g.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      if (!frames[i].getAttribute('title')) frames[i].setAttribute('title', G_FRAME_TITLE);
    }
  }

  function drawer() { return document.getElementById(DRAWER_ID); }
  function menuOpen() { var d = drawer(); return !!(d && d.hasAttribute('open') && d.offsetWidth > 0); }

  var WIDGET_HOSTS = 'access-widget-ui, csm-cookie-consent, [id*="merchantwidget"]';

  function isWidgetNode(node) {
    return !!(node && node.closest && node.closest(WIDGET_HOSTS));
  }
  function eventHitsWidget(event) {
    var deep = (event.composedPath && event.composedPath()[0]) || null;
    return isWidgetNode(deep) || isWidgetNode(event.target);
  }

  function protectDrawer() {
    var d = drawer();
    if (!d || d.__arg17Protected) return;
    d.__arg17Protected = true;

    var native = Node.prototype.contains;
    d.contains = function (node) {
      if (native.call(this, node)) return true;
      return isWidgetNode(node);
    };

    var origTouch = d._allowOutsideClickTouch;
    var origMouse = d._allowOutsideClickMouse;
    d._allowOutsideClickTouch = function (event) {
      if (eventHitsWidget(event)) return true;
      return origTouch.call(this, event);
    };
    d._allowOutsideClickMouse = function (event) {
      if (eventHitsWidget(event)) return true;
      return origMouse.call(this, event);
    };
  }

  /* ---------- style helpers ---------- */
  function setImp(el, prop, val) {
    if (el.style.getPropertyValue(prop) !== val) { writeCount++; el.style.setProperty(prop, val, 'important'); }
  }
  function clearProp(el, prop) {
    if (el.style.getPropertyValue(prop) !== '') { writeCount++; el.style.removeProperty(prop); }
  }
  function show(el) { clearProp(el, 'visibility'); clearProp(el, 'pointer-events'); }
  function hide(el) { setImp(el, 'visibility', 'hidden'); setImp(el, 'pointer-events', 'none'); }

  var CSM_UNPOP_MAX = 20;
  var csmUnpopCount = 0;
  var csmUnpopped = false;

  function shieldStacking(host, belowZ) {
    if (csmPanelVisible()) {
      clearProp(host, 'z-index');
      if (typeof host.showPopover === 'function' && !host.matches(':popover-open')) {
        try { host.showPopover(); } catch (e) {}
      }
      csmUnpopped = false;
      return;
    }

    setImp(host, 'z-index', belowZ);
    if (csmUnpopCount >= CSM_UNPOP_MAX) return;
    if (typeof host.hidePopover !== 'function') return;
    try {
      if (host.matches(':popover-open')) {
        host.hidePopover();
        csmUnpopped = true;
        csmUnpopCount++;
      }
    } catch (e) {
      csmUnpopCount = CSM_UNPOP_MAX;
    }
  }

  function shieldIcon(s) {
    if (!s) return null;
    var i = s.querySelector('[class*="reopen"]');
    return (i && i !== s) ? i : null;
  }

  /* ---------- accessiBe interface open? ---------- */
  function acsbInterfaceOpen() {
    var a = cache.a;
    if (a && a.isConnected && /trigger-button--visible/.test(String(a.className))) return false;
    var el = cache.ai;
    if (!(el && el.isConnected)) {
      el = null;
      var hosts = document.querySelectorAll('access-widget-ui');
      for (var i = 0; i < hosts.length && !el; i++) {
        var sr = hosts[i].shadowRoot;
        if (!sr) continue;
        var all = sr.querySelectorAll('*');
        for (var j = 0; j < all.length; j++) {
          var r = all[j].getBoundingClientRect();
          if (r.width > 250 && r.height > 400) { el = all[j]; break; }
        }
      }
      cache.ai = el;
      if (el) watchClassStyle(el);
    }
    if (!el) return false;
    var cs = getComputedStyle(el);
    var rr = el.getBoundingClientRect();
    return cs.visibility !== 'hidden' && cs.display !== 'none' && rr.width > 250 && rr.height > 400;
  }

  /* ---------- Consentmo settings panel ---------- */
  function csmScan() {
    var h = document.querySelector('csm-cookie-consent');
    if (!h || !h.shadowRoot) return null;
    var best = null;
    h.shadowRoot.querySelectorAll('div').forEach(function (el) {
      var cs = getComputedStyle(el);
      var r = el.getBoundingClientRect();
      var vis = cs.visibility !== 'hidden' && cs.display !== 'none' && r.width > 0;
      var isBig = r.width > 200 && r.height > 150;
      if (el.__ptDlg && (!vis || !isBig)) { el.style.removeProperty('left'); el.__ptDlg = false; }
      if (vis && isBig && r.width < window.innerWidth * 0.9) {
        if (!best || r.width * r.height > best.r.width * best.r.height) best = { el: el, r: r };
      }
    });
    return best;
  }
  
  function csmPanelVisible() {
    var h = document.querySelector('csm-cookie-consent');
    if (!h || !h.shadowRoot) return false;
    var found = false;
    h.shadowRoot.querySelectorAll('div').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.visibility === 'hidden' || cs.display === 'none') return;
      var r = el.getBoundingClientRect();
      var panel = r.width > 200 && r.height > 150;
      var bar   = r.width > window.innerWidth * 0.6 && r.height > 60;
      if (panel || bar) found = true;
    });
    return found;
  }
  function steerCsmPanel(best) {
    if (!best) return;
    var vw = window.innerWidth;
    var want = Math.max(4, Math.round(vw - best.r.width - 20));
    var delta = Math.round(best.r.left - want);
    if (Math.abs(delta) > 2) {
      var base = parseFloat(best.el.style.getPropertyValue('left'));
      if (isNaN(base)) base = parseFloat(getComputedStyle(best.el).left);
      if (isNaN(base)) base = 0;
      setImp(best.el, 'left', Math.round(base - delta) + 'px');
      best.el.__ptDlg = true;
    }
  }

  /* ---------- the one state function ---------- */
  function sync() {
    var g = google(), s = shield(), a = acsb();
    var desktop = mqDesktop.matches;

    if (g) titleGoogleFrame(g);

    protectDrawer();

    if (!desktop && !menuOpen()) {
      ducked = false;
      var panelUp = csmPanelVisible();
      if (g) setImp(g, 'display', 'none');
      if (s) {
        var icon = shieldIcon(s);
        if (icon) {
          setImp(icon, 'visibility', 'hidden');
          setImp(icon, 'pointer-events', 'none');
          clearProp(s, 'visibility');
          if (panelUp) clearProp(s, 'pointer-events');
          else setImp(s, 'pointer-events', 'none');
        } else if (panelUp) {
          show(s);
        } else {
          hide(s);
        }
      }
      if (a) hide(a);
      steerCsmPanel(csmScan());
      return;
    }

    ducked = acsbInterfaceOpen();
    if (ducked) {
      if (g) setImp(g, 'display', 'none');
      if (s) {
        var ic3 = shieldIcon(s);
        if (ic3) { setImp(ic3, 'visibility', 'hidden'); setImp(ic3, 'pointer-events', 'none'); }
        else hide(s);
      }
      steerCsmPanel(csmScan());
      return;
    }

    var cRight, inset, base;
    if (desktop) {
      cRight = window.innerWidth; inset = DT_INSET; base = DT_BASE;
    } else {
      var d = drawer();
      var pn = d.querySelector('.panel-list__wrapper') || d;
      var r = pn.getBoundingClientRect();
      cRight = r.right; inset = M_SIDE;
      base = Math.round(Math.max(0, window.innerHeight - r.bottom)) + M_BOTTOM;
    }

    if (s) {
      var icon2 = shieldIcon(s);
      if (icon2) { clearProp(icon2, 'visibility'); clearProp(icon2, 'pointer-events'); }
      show(s);
    }
    if (a) show(a);
    if (g) setImp(g, 'display', 'block');

    var gw = g ? (g.offsetWidth || 84) : 84, gh = g ? (g.offsetHeight || 84) : 84;
    var sw = s ? (s.offsetWidth || 55) : 55, sh = s ? (s.offsetHeight || 55) : 55;
    var aw = a ? (a.offsetWidth || 45) : 45, ah = a ? (a.offsetHeight || 45) : 45;
    var expanded = gh > 150;
    if (!expanded && g) { lastGw = gw; lastGh = gh; }
    var ghNom = expanded ? lastGh : gh;
    var gwNom = expanded ? lastGw : gw;
    var gVis = Math.min(gwNom, ghNom);
    var rowH = Math.max(sh, ah, gVis, 1);
    var gRightWanted = Math.round(window.innerWidth - cRight + inset);
    var gRight = gRightWanted;
    if (window.innerWidth - gRight - gw < 8) gRight = Math.max(4, window.innerWidth - gw - 8);
    if (g) {
      var gBottom;
      if (!expanded) {
        gBottom = Math.round(base + (rowH - gh) / 2);
      } else {
        var anchor = Math.round(base + (rowH - ghNom) / 2);
        gBottom = Math.min(anchor, window.innerHeight - gh - 8);
      }
      if (gBottom < 4) gBottom = 4;
      setImp(g, 'top', 'auto');
      setImp(g, rt_aligned ? "left" : "right", 'auto');
      setImp(g, rt_aligned ? "right" : "left", gRight + 'px');
      setImp(g, 'bottom', gBottom + 'px');
    }

    var gNomLeft = (window.innerWidth - gRight) - gVis;
    var aLeft = gNomLeft + G_ICON_PAD - GAP - aw - (desktop ? DT_ACSB_GAP_RIGHT : 0);
    var sLeft = aLeft - GAP - sw;
    var gZ = g ? (parseInt(getComputedStyle(g).zIndex, 10) || 2147483647) : 2147483647;
    var stackBelowG = String(Math.max(0, gZ - 1));

    if (a) {
      if (desktop) {
        var cw = document.documentElement.clientWidth;
        setImp(a, 'top', 'auto');
        setImp(a, rt_aligned ? "right" : "left", 'auto');
        setImp(a, rt_aligned ? "left" : "right", Math.round(cw - DT_ACSB_RIGHT - aw) + 'px');
        setImp(a, 'bottom', DT_ACSB_BOTTOM + 'px');
      } else {
        setImp(a, 'top', 'auto');
        setImp(a, rt_aligned ? "right" : "left", 'auto');
        setImp(a, rt_aligned ? "left" : "right", Math.round(aLeft) + 'px');
        setImp(a, 'bottom', Math.round(base + (rowH - ah) / 2) + 'px');
      }
      setImp(a, 'z-index', stackBelowG);
    }
    if (s) {
      if (desktop) {
        var cwS = document.documentElement.clientWidth;
        setImp(s, 'top', 'auto');
        setImp(s, rt_aligned ? "right" : "left", 'auto');
        setImp(s, rt_aligned ? "left" : "right", Math.round(cwS - DT_SHIELD_RIGHT - sw) + 'px');
        setImp(s, 'bottom', DT_SHIELD_BOTTOM + 'px');
      } else {
        setImp(s, 'top', 'auto');
        setImp(s, rt_aligned ? "right" : "left", 'auto');
        setImp(s, rt_aligned ? "left" : "right", Math.round(sLeft) + 'px');
        setImp(s, 'bottom', Math.round(base + (rowH - sh) / 2) + 'px');
      }
      setImp(s, 'z-index', stackBelowG);
      s.__arg17Placed = true;
    }

    var csmHost = document.querySelector('csm-cookie-consent');
    if (csmHost) shieldStacking(csmHost, stackBelowG);

    steerCsmPanel(csmScan());
  }

  function shieldNeedsPlacement() {
    var el = shield();
    return !!(el && !el.__arg17Placed);
  }

  function run() {
    if (Date.now() < pauseUntil && !shieldNeedsPlacement()) return;
    var w0 = writeCount;
    try { sync(); } catch (e) { /* never take the page down */ }
    hotTicks = (writeCount > w0) ? hotTicks + 1 : 0;
    if (hotTicks > 60) {
      hotTicks = 0;
      pauseUntil = Date.now() + 3000;
      return;
    }
    var d = drawer();
    if ((!mqDesktop.matches && d && d.hasAttribute('open')) || ducked) schedule();
  }


  function init() {
    var d = drawer();
    if (d) {
      new MutationObserver(schedule).observe(d, { attributes: true, attributeFilter: ['open'] });
    }
    mqDesktop.addEventListener ? mqDesktop.addEventListener('change', schedule) : mqDesktop.addListener(schedule);
    window.addEventListener('resize', schedule);
    document.addEventListener('visibilitychange', schedule);
    setInterval(schedule, 1200);
    var mo = new MutationObserver(function () {
      var ok = cache.g && cache.g.isConnected && cache.s && cache.s.isConnected && cache.a && cache.a.isConnected;
      if (!ok) schedule();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();